import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetCustomersData from "../../Comman/GetCustomersData";
import GetSoldItesmData from "../../Comman/GetSoldItesmData";
import GetEarnings from "../../Comman/GetEarnings";
import GetAssignerUserSaleReturnDataInFirebase from "../AssignerUser/SaleReturn/GetAssignerUserSaleReturnDataInFirebase";

const GetSaleReturnDataFirebase = async (state, dispatch, sharedBusinesses = null) => {
    if (!state?.USERID || state?.USERID == null || state?.USERID == undefined) return null;

    try {
        const userRef = ref(database, `invoiceGenerator/users/${state?.USERID}/returnInvoice`);
        const snapshot = await get(userRef);
        const data = snapshot.val();

        const formattedData = data
            ? Object.entries(data)
                .filter(([, invoice]) => !invoice?.isDeleted)
                .map(([uniqueID, info]) => ({
                    uniqueID,
                    ...info,
                    isShared: false
                }))
            : [];

        if (formattedData.length > 0) {
            GetEarnings(state, dispatch, Object.entries(data).filter(([, invoice]) => !invoice?.isDeleted));
        }

        let finalSaleReturnData = formattedData;

        /* -------- FETCH SHARED SALE RETURNS -------- */

        const businessesToUse = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];
        if (businessesToUse.length) {
            const sharedInvoices = await GetAssignerUserSaleReturnDataInFirebase(state, dispatch, businessesToUse);
            finalSaleReturnData = [
                ...formattedData,
                ...sharedInvoices
            ];
        }

        /* -------- REMOVE DUPLICATES & SORT & NUMBER -------- */

        const saleReturnIdMap = new Map();

        finalSaleReturnData.forEach((inv) => {
            const key = inv.isShared ? `shared_${inv.uniqueID}` : `local_${inv.uniqueID}`;
            saleReturnIdMap.set(key, inv);
        });

        const dedupedSaleReturns = Array.from(saleReturnIdMap.values());

        const sortedInvoiceData = dedupedSaleReturns
            .sort((a, b) => new Date(parseInt(b.date)) - new Date(parseInt(a.date)))
            .map((item, index) => ({
                srNo: index + 1, // Assign serial number after sorting
                ...item,
            }));

        dispatch({ type: actionType.SALERETURN, payload: sortedInvoiceData });

        return sortedInvoiceData;
    } catch (error) {
        console.error("Error fetching inovice data:", error);
        return null;
    }
};

export default GetSaleReturnDataFirebase;